import { defaultTransformation } from './default-transformation';
import { categoricalChartTransformation, choroplethChartTransformation, tableChartTransformation, } from './charts';
export var transformCategorical = function (_a, parserSettings, visualization) {
    var query = _a.query, result = _a.result;
    if (visualization === 'bar' || visualization === 'heatmap') {
        return categoricalChartTransformation(result, parserSettings);
    }
    if (visualization === 'table') {
        return tableChartTransformation(result, query === null || query === void 0 ? void 0 : query.analysis_type, query === null || query === void 0 ? void 0 : query.event_collection);
    }
    if (visualization === 'choropleth' &&
        Array.isArray(query === null || query === void 0 ? void 0 : query.group_by) &&
        query.group_by.length > 1) {
        return choroplethChartTransformation(result, parserSettings, query.group_by);
    }
    return defaultTransformation(result, parserSettings);
};
